import { TeamBadge } from "@/components/TeamBadge";
import { useI18n } from "@/context/I18nContext";
import { Trophy, Swords, XCircle } from "lucide-react";

function Row({ row }) {
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 border-t border-border first:border-t-0" data-testid={`bracket-team-${row.short}`}>
      <span className="font-display text-base w-6 text-center text-muted-foreground">{row.position}</span>
      <TeamBadge team={row} size={24} />
      <span className="font-medium flex-1 truncate">{row.name}</span>
      <span className="font-display text-primary">{row.points}</span>
    </div>
  );
}

export function BracketView({ bracket }) {
  const { t } = useI18n();
  if (!bracket) return null;

  return (
    <div>
      <p className="overline text-primary mb-4">{t("bracket.projected")}</p>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Direct */}
        <div className="bg-card border border-primary/40" data-testid="bracket-direct">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
            <Trophy size={16} className="text-primary" />
            <p className="overline text-primary">{t("bracket.direct")}</p>
          </div>
          {bracket.direct.map((r) => <Row key={r.team_id} row={r} />)}
        </div>

        {/* Playoffs */}
        <div className="bg-card border border-border" data-testid="bracket-playoffs">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
            <Swords size={16} className="text-foreground" />
            <p className="overline text-muted-foreground">{t("bracket.playoff")}</p>
          </div>
          {bracket.playoffs.map((tie, i) => (
            <div key={i} className="px-4 py-2.5 border-t border-border first:border-t-0" data-testid={`bracket-tie-${i}`}>
              <div className="flex items-center gap-2 text-sm">
                <span className="font-display text-muted-foreground w-5">{tie.high.position}</span>
                <TeamBadge team={tie.high} size={22} />
                <span className="font-medium flex-1 truncate">{tie.high.short}</span>
                <span className="text-muted-foreground text-xs px-1">vs</span>
                <span className="font-medium flex-1 truncate text-right">{tie.low.short}</span>
                <TeamBadge team={tie.low} size={22} />
                <span className="font-display text-muted-foreground w-5 text-right">{tie.low.position}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Eliminated */}
        <div className="bg-card border border-border opacity-70" data-testid="bracket-eliminated">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
            <XCircle size={16} className="text-destructive" />
            <p className="overline text-muted-foreground">{t("bracket.eliminated")}</p>
          </div>
          {bracket.eliminated.map((r) => <Row key={r.team_id} row={r} />)}
        </div>
      </div>
    </div>
  );
}
